﻿import { Space, Typography } from "antd";
import { bool, string } from "prop-types";
import { useIntl } from "react-intl";

const { Text } = Typography;

const NO_SPACING = 0;

const UserOptionLabel = ({ displayName, email, jobTitle, department }) => {
  const intl = useIntl();

  return (
    <Space direction="vertical" size={NO_SPACING}>
      <Text className="font-bold">{displayName}</Text>
      {!!email && (
        <Text type="secondary">
          <small>
            {intl.formatMessage({ id: "home.email" })}: {email}
          </small>
        </Text>
      )}
      {!!jobTitle && (
        <Text type="secondary">
          <small>
            {intl.formatMessage({ id: "permissions.jobTitleInputLabel" })}{" "}
            {jobTitle}
          </small>
        </Text>
      )}
      {!!department && (
        <Text type="secondary">
          <small>
            {intl.formatMessage({ id: "permissions.departmentInputLabel" })}{" "}
            {department}
          </small>
        </Text>
      )}
    </Space>
  );
};

UserOptionLabel.propTypes = {
  displayName: string.isRequired,
  email: string,
  jobTitle: string,
  department: string,
  azureAdAccountEnabled: bool,
};

export default UserOptionLabel;
